
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared/tiktok-content/[sharedToken]",
      function () {
        return require("private-next-pages/shared/tiktok-content/[sharedToken].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared/tiktok-content/[sharedToken]"])
      });
    }
  